export const companyInfo = {
  name: 'Hellio Solutions',
  address: '50 Rue Madame De Sanzillon, 92110 Clichy',
  email: 'solutions@hellio.com',
};

export default companyInfo;
